import { ApolloClient, InMemoryCache } from '@apollo/client';
import typePolicies from './typePolicies';
import link from './apolloLink';

const client = token =>
  new ApolloClient({
    ssrMode: true,
    link: link({ token }),
    cache: new InMemoryCache({
      typePolicies,
    }).restore(
      // eslint-disable-next-line no-underscore-dangle
      window.__APOLLO_STATE__ ? JSON.parse(window.__APOLLO_STATE__) : null
    ),
  });

export default client;
